/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import NetworkNodeType = Models.NetworkNodeType;
    import IDeviceAlarmConfig = Models.IDeviceAlarmConfig;
    import IAlarmConfig = Models.IAlarmConfig;
    import NetworkNode = Models.NetworkNode;
    import ISonLink = Models.ISonLink;
    import ISonNode = Models.ISonNode;
    import INamedEntity = Models.INamedEntity;
    import IConditionAlarmConfigMap = Models.IConditionAlarmConfigMap;

    interface IAlarmsTemplatesRouteParamsService extends ng.route.IRouteParamsService {
        deviceClass: string;
        typeId: string;
    }

    export class AdminAlarmsTemplatesController {
        public static $name: string = "adminAlarmsTemplatesController";
        public static $inject: string[] = ['$routeParams',
                                           'alarmsService',
                                           'networkNodeTypeService',
                                           'networkNodeService',
                                           'ModalService',
                                           'messageTranslationsService',
                                           'sonAdapterService',
                                           '$q',
                                           '$timeout',
        ];

        public networkNodeTypes: NetworkNodeType[];
        public networkNodeType: NetworkNodeType;
        public severityColors: string[];
        // public alarmsConfigsCopy: IConditionAlarmConfigMap = {};
        public errorsMap: string[];
        public networkNodes: NetworkNode[];
        public links: ISonLink[];
        public switches: ISonNode[];
        public conditionKeys: string[];
        public conditionAlarmConfigMap: IConditionAlarmConfigMap = {};
        public conditionAlarmConfigCopyMap: IConditionAlarmConfigMap = {};
        public selectedCondition: string;
        public templateChanged: boolean = false;

        private searchText: string;
        private timeoutSearch: ng.IPromise<void>;
        private matchedNodeTypes: NetworkNodeType[];

        constructor(private $routeParams: IAlarmsTemplatesRouteParamsService,
                    private alarmsService: Services.AlarmsService,
                    private networkNodeTypeService: Services.NetworkNodeTypeService,
                    private networkNodeService: Services.NetworkNodeService,
                    private modalService: ngModal.IModalService,
                    private messageTranslationsService: Services.MessageTranslationsService,
                    private sonAdapterService: Services.SonAdapterService,
                    private qService: ng.IQService,
                    private $timeout: ng.ITimeoutService) {

            this.searchText = "";

            let deviceClass: string = $routeParams.deviceClass;
            let typeId: number = parseInt($routeParams.typeId, 10);
            // network node type template view
            if (!isNaN(typeId) && typeId >= 0) {
                    if (deviceClass === 'networkNodeTypes') {
                        this.loadNetworkNodeType(typeId);
                    } else if (deviceClass === 'switchTypes') {
                        // switches
                        this.networkNodeType = this.buildSwitchesNetworkNodeType();
                        this.loadAlarmConfigsForTypeHrefAndPacketMap().then((packetMap: Models.ISonPacketmap) => {
                            this.switches = packetMap.switches.filter((node: ISonNode) => {
                                return node.group === 'packet';
                            });
                        });
                    } else if (deviceClass === 'sonLinkTypes') {
                        // sonLinks
                        this.networkNodeType = this.buildSonLinksNetworkNodeType();
                        this.loadAlarmConfigsForTypeHrefAndPacketMap().then((packetMap: Models.ISonPacketmap) => {
                            this.links = packetMap.links;
                        });
                    }
            } else {
                this.loadNetworkNodeTypesList();
            }
        }

        public simpHref(networkNodeType: NetworkNodeType): string {
            return Common.Utils.getSimplifiedHrefFromString(networkNodeType.href);
        }

        public alarmsHaveBeenChanged(): boolean {
            let copy: IDeviceAlarmConfig = this.getCurrentDeviceAlarmConfigCopy();
            let orig: IDeviceAlarmConfig = this.getCurrentDeviceAlarmConfig();
            if (Common.Utils.exists(orig) && Common.Utils.exists(copy)) {
                this.errorsMap = this.alarmsService.validateAlarmConfigsValues(copy);
                this.templateChanged = this.alarmsService.alarmsHaveBeenChanged(orig.alarmConfigs, copy.alarmConfigs);
            } else {
                this.templateChanged = false;
            }
            return this.templateChanged;
        }

        public changeMaskParam(alarmConfig: IAlarmConfig): void {
            if (this.networkNodeType !== undefined) {
                alarmConfig.masked = !alarmConfig.masked;
            }
        };

        public changeMaskLevel(alarmConfig: IAlarmConfig, index: number): void {
            if (this.networkNodeType !== undefined) {
                if ((alarmConfig.type as string) === 'relay' ||
                    (Common.Utils.exists(alarmConfig.levels[index].value) && alarmConfig.levels[index].value !== ''))
                    alarmConfig.levels[index].masked = !alarmConfig.levels[index].masked;
            }
        };

        public discardChanges(): void {
            this.conditionAlarmConfigCopyMap[this.selectedCondition].alarmConfigs =
                angular.copy(this.getCurrentDeviceAlarmConfig().alarmConfigs);
        }

        public saveChanges(): void {
            let copy: IDeviceAlarmConfig = this.getCurrentDeviceAlarmConfigCopy();
            this.errorsMap = this.alarmsService.validateAlarmConfigsValues(copy);
            if (!this.errorsMap) {
                this.alarmsService
                    .saveAlarmConfigs(copy)
                    .then((alarmConfig: IDeviceAlarmConfig) => {
                        this.conditionAlarmConfigMap[alarmConfig.condition] = alarmConfig;
                        this.conditionAlarmConfigCopyMap[alarmConfig.condition] = Common.Utils.clone(alarmConfig) as IDeviceAlarmConfig;
                    });
            }
        }

        public applyTemplateToAll(deviceClass: string): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                controller: Application.Controllers.ConfirmModalController.$name,
                inputs: {
                    title: 'Apply template to ' + 'all ' + deviceClass +  '?',
                    description: 'This action cannot be undone.',
                    name: '',
                    type: 'information',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: string) => {
                    modalElem.hide();
                    if (result) {
                        let hrefs: string[] = [];
                        let devices: INamedEntity[];
                        if (deviceClass === 'links')
                            devices = this.links;
                        if (deviceClass === 'switches')
                            devices = this.switches;
                        if (deviceClass === 'nodes')
                            devices = this.networkNodes;
                        for (let nn of devices) {
                            hrefs.push(Common.Utils.getSimplifiedHrefFromString(nn.href).substr(1));
                        }
                        this.doApplyTemplateToHrefs(hrefs);
                    }
                });
            });
        }

        public applyTemplate(entity: INamedEntity): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                controller: Application.Controllers.ConfirmModalController.$name,
                inputs: {
                    title: 'Apply template to ' + (entity ? entity.name : 'all devices') + '?',
                    description: 'This action cannot be undone.',
                    name: '',
                    type: 'information',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: string) => {
                    modalElem.hide();
                    if (result) {
                        let hrefs: string[] = [Common.Utils.getSimplifiedHrefFromString(entity.href).substr(1)];
                        this.doApplyTemplateToHrefs(hrefs);
                    }
                });
            });
        }

        public getSeverityColor(severity: number): string {
            return this.alarmsService.getSeverityColor(severity);
        };

        public escapeId(conditionKey: string, paramName: string): string {
            return conditionKey + "_" + paramName.replace(/\[/g, "_").replace(/\]/g, "_").replace(/\./g, "_");
        }

        public searchAsType(): void {
            if (this.searchText !== undefined && this.searchText !== "") {
                this.$timeout.cancel(this.timeoutSearch);
                this.timeoutSearch = this.$timeout(() => {
                    this.applyFilter();
                }, 500);
            } else {
                this.matchedNodeTypes = this.networkNodeTypes;
            }
        }

        public applyFilter(): void {
            this.matchedNodeTypes = this.networkNodeTypes;
            this.matchedNodeTypes = this.networkNodeTypes.filter((element: NetworkNodeType) => {
                return element.name.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1;
            });
        }

        private doApplyTemplateToHrefs(hrefs: string[]): void {
            this.qService.all(Object.keys(this.conditionAlarmConfigCopyMap).map((condition: string) => {
                let alarmConfig: IDeviceAlarmConfig = this.conditionAlarmConfigCopyMap[condition];
                return this.alarmsService
                .applyTemplateToDevices(alarmConfig, hrefs);
                
            }))
            .then(() => {
                Common.Utils.alertOnInfo("Alarms configuration applied correctly.");
            })
            .catch(() => {
                this.messageTranslationsService.alertOnError("Something was wrong!");
            });
        }


        private loadAlarmConfigsForTypeHrefAndPacketMap(): ng.IPromise<Models.ISonPacketmap> {
            return this.alarmsService.getAlarmConfigsByHref(this.networkNodeType.href)
                .then((alarmConfigs: IDeviceAlarmConfig[]) => {
                    this.selectAlarmConfigForCondition(alarmConfigs);
                    return this.sonAdapterService.getSonPacketmap();
                });
        }

        private selectAlarmConfigForCondition(alarmConfigs: IDeviceAlarmConfig[]): void {
            this.conditionAlarmConfigMap = {};
            this.conditionAlarmConfigCopyMap = {};
            alarmConfigs.forEach((deviceAlarmConfig: IDeviceAlarmConfig) => {
                this.conditionAlarmConfigMap[deviceAlarmConfig.condition] = deviceAlarmConfig;
                this.conditionAlarmConfigCopyMap[deviceAlarmConfig.condition] = Common.Utils.clone(deviceAlarmConfig) as IDeviceAlarmConfig;
            });
            this.conditionKeys = Object.keys(this.conditionAlarmConfigMap);
            this.conditionKeys.sort().reverse();
            this.selectedCondition = "operation";
            // this.alarmsConfigs = this.conditionAlarmConfigMap[this.selectedCondition];
            // this.alarmsConfigsCopy = Common.Utils.clone(this.alarmsConfigs) as IDeviceAlarmConfig;
        }

        private loadNetworkNodeTypesList(): void {
            this.networkNodeTypeService
                .getAllNetworkNodeTypes()
                .then((networkNodeTypes: NetworkNodeType[]) => {
                    this.networkNodeTypes = networkNodeTypes.slice();
                    this.networkNodeTypes.forEach((nnt: NetworkNodeType) => {
                        nnt.id = Common.Utils.idFromHref(nnt.href);
                    });
                    this.networkNodeTypes.push(this.buildSonLinksNetworkNodeType());
                    this.networkNodeTypes.push(this.buildSwitchesNetworkNodeType());
                    this.matchedNodeTypes = this.networkNodeTypes;
                });
        }

        private loadNetworkNodeType(networkNodeTypeId: number): void {
            this.networkNodeTypeService
                .findById(networkNodeTypeId)
                .then((networkNodeType: Models.NetworkNodeType) => {
                    this.networkNodeType = networkNodeType;
                    this.alarmsService.getAlarmConfigsByHref(this.networkNodeType.href)
                        .then((alarmConfigs: IDeviceAlarmConfig[]) => {
                            this.selectAlarmConfigForCondition(alarmConfigs);

                            this.networkNodeService
                                .getAllByNetworkNodeTypeId(this.networkNodeType.id)
                                .then((networkNodes: NetworkNode[]) => {
                                    this.networkNodes = networkNodes.sort((node1: NetworkNode, node2: NetworkNode) => node1.name.localeCompare(node2.name));
                                });
                        });
                });
        }

        private buildSonLinksNetworkNodeType(): NetworkNodeType {
            let sonLinksNetworkNodeType: NetworkNodeType = new NetworkNodeType();
            sonLinksNetworkNodeType.name = "SON LINKS";
            sonLinksNetworkNodeType.vendor = "FLEX";
            sonLinksNetworkNodeType.href = "/sonLinkTypes/1";
            sonLinksNetworkNodeType.id = 1;
            return sonLinksNetworkNodeType;
        }

        private buildSwitchesNetworkNodeType(): NetworkNodeType {
            let switchesNetworkNodeType: NetworkNodeType = new NetworkNodeType();
            switchesNetworkNodeType.name = "SWITCHES";
            switchesNetworkNodeType.vendor = "FLEX";
            switchesNetworkNodeType.id = 1;
            switchesNetworkNodeType.href = "/switchTypes/1";
            return switchesNetworkNodeType;
        }

        private getCurrentDeviceAlarmConfig(): IDeviceAlarmConfig {
            return this.conditionAlarmConfigMap[this.selectedCondition];
        }

        private getCurrentDeviceAlarmConfigCopy(): IDeviceAlarmConfig {
            return this.conditionAlarmConfigCopyMap[this.selectedCondition];
        }

        private launchAclModal(alarmConfig: IAlarmConfig): void {
            const typeName: string = 'alarmConfigs';
            const aclEntityId: number = this.getAclId(alarmConfig);
            const aclEntity = { href: `${typeName}/${aclEntityId}` };


            this.modalService.showModal({
                templateUrl: Controllers.AclModalController.templateURL,
                controller: Controllers.AclModalController.$name,
                inputs: {
                    entity: aclEntity,
                    entityTypeName: typeName,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.AclModalController.ID,
                            {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then(() => {
                    modalElem.hide();
                });
            });
        }

        private getAclId(alarmConfig: IAlarmConfig): number {
            return this.selectedCondition === 'operation' ? this.getConnectedId(alarmConfig.paramName) : alarmConfig.id;
        }

        private getConnectedId(paramName: string): number {
            return this.conditionAlarmConfigMap['connected'].alarmConfigs.filter((alarmConfigConnected: IAlarmConfig) =>
                paramName === alarmConfigConnected.paramName
            )[0].id;
        }

        private setMailAlert(alarmConfig: IAlarmConfig, index: number): void {
            if (!alarmConfig.masked && !alarmConfig.levels[index].masked &&
                ((alarmConfig.type as string) === 'relay' ||
                (Common.Utils.exists(alarmConfig.levels[index].value) && alarmConfig.levels[index].value !== ''))) {

                alarmConfig.levels[index].emailAlert = !alarmConfig.levels[index].emailAlert;
            }
        }
    }
}
